import { ConfirmChangeEmail } from '@livable/saas-react-components';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useStore } from 'src/stores';
const Component = () => {
  const store = useStore();
  return /*#__PURE__*/React.createElement(ConfirmChangeEmail, {
    confirm: store.account.confirmAnAccountsEmailAsync,
    refresh: false
  });
};
export const ConfirmChangeEmailPage = observer(Component);